import React from 'react';
import PropTypes from 'prop-types';

import { styled, up, css, th } from '@smooth-ui/core-sc';

const BannerWrapper = styled.div`
  position: relative;
`;

const BannerContainer = styled.div`
  ${props => (props.pageTitle ? null : `height: 390px`)};
  ${props =>
    props.bannerDesktop
      ? `background-image: url(${props.bannerDesktop});`
      : null};
  background-position: center center;
  background-size: cover;

  @media only screen and (min-device-pixel-ratio: 1.5),
    only screen and (min-resolution: 144dpi),
    only screen and (min-resolution: 1.5dppx) {
    ${props =>
      props.bannerDesktop || props.bannerDesktop2x
        ? `background-image: url(${props.bannerDesktop2x ||
            props.bannerDesktop});`
        : null};
  }

  .banner__title {
    h1,
    h2 {
      font-size: 50px;
      margin: 0;
      padding: 10px;
      line-height: 1;
      mix-blend-mode: overlay;
      font-weight: normal;
      color: ${th('secondary')};
      ${up(
        'sm',
        css`
          font-size: 150px;
        `
      )};
    }

    h1 {
      padding: 50px 10px;
      min-height: 330px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      span {
        ${up(
          'sm',
          css`
            font-size: 50px;
          `
        )};
      }
    }
    position: relative;
    text-align: center;
    font-family: 'cowboyslang', sans-serif;
    text-transform: uppercase;
    color: #d4883d;
    width: 100%;
    span {
      font-size: 30px;
      display: block;
      ${up(
        'sm',
        css`
          font-size: 80px;
        `
      )};
    }
  }
`;

const HeadingBanner = props => (
  <BannerWrapper className="banner-wrapper">
    <BannerContainer {...props}>
      <div className="banner__title">{props.pageTitle}</div>
    </BannerContainer>
  </BannerWrapper>
);

HeadingBanner.propTypes = {
  pageTitle: PropTypes.object.isRequired,
};

export default HeadingBanner;
